import { type FC } from 'react';
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Step4: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column w-100">
      <div className="d-flex align-items-center mb-6">
        <h3 className="stepper-title me-7">Finalizado</h3>
        <div className="stepper-desc opacity-50">Oba, sistema pronto para uso!</div>
      </div>
      <div className="card h-auto d-flex align-items-center justify-content-center">
        <div className="card-body p-4 p-lg-10 pt-lg-4 w-100">
          <div className="d-flex flex-column align-items-center justify-content-center">
            <Image alt="setup-done" height={220} src="/media/illustrations/setup/Concord.png" width={220} />
            <div className="d-flex align-items-center justify-content-center">
              <p style={{ fontSize: '25px' }}>&#127881;</p>
              <h3 className="stepper-title me-7">Tudo pronto para começar!</h3>
            </div>
            <div className="stepper-desc opacity-50 text-center mb-4">
              Seu sistema está configurado com sucesso. Agora é só aproveitar todas as funcionalidades e facilitar a
              gestão da sua empresa.
            </div>
            <div
              className="btn btn-primary btn-sm mb-8"
              onClick={() => {
                navigate('../auth');
              }}
            >
              Acessar sistema
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
